import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { isSignedInSelector } from 'reduxModules/selectors/AuthSelectors'
import { isClientSelector, userIdSelector } from 'reduxModules/selectors/UserSelectors'
import { allCitiesSelector } from 'reduxModules/selectors/CitySelectors'
import {
  isLogisticPageSelector,
  isPricesPageSelector,
  isRoutesPageSelector,
  isBookPageSelector,  
} from 'reduxModules/selectors/RouterSelectors'
import { routeActions } from 'reduxModules/actions/RouteActions'
import { cityActions } from 'reduxModules/actions/CityActions'

import SignedInLayoutBase from './SignedInLayout'

const mapStateToProps = createStructuredSelector({
  isSignedIn: isSignedInSelector,
  userId: userIdSelector,
  allCities: allCitiesSelector,
  isLogisticPage: isLogisticPageSelector,
  isPricesPage: isPricesPageSelector,
  isClient: isClientSelector,
  isRoutesPage: isRoutesPageSelector,
  isBookPage: isBookPageSelector,
})

const mapDispatchToProps = {
  getRoutes: routeActions.getRoutes,
  getAllCities: cityActions.getAllCities,
}

export const SignedInLayout = connect(mapStateToProps, mapDispatchToProps)(SignedInLayoutBase)


// WEBPACK FOOTER //
// ./src/layouts/SignedInLayout/index.js